import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { Link, useParams } from "react-router-dom";
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../../Context/AuthContext";

import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import DummyImg from "../../../Public/Images/568165.png";

function UnitDetails({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);
  const { designation, userDetails } = useAuth();

  const [loading, setLoading] = useState(false);
  const [viewImage, setViewImage] = useState([]);
  const [savedImage, setsavedImage] = useState([]);
  const [unitData, setUnitData] = useState({});
  const value = useParams();
  const BuildId = value.id;
    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();;

  const {
    Buildings,
    Building_code,
    Tenant,
    unit_category,
    unit_type,
    unit_image,
    unit_start_date,
    unit_end_date,
    unit_description,
    payment_mode,
    monthly_rate,
    city,
    taxes,
    apartment_size,
    unit_name,
    building_id,
  } = unitData;

  useEffect(() => {
    if (BuildId) {
      getBuildingValue();
    }
  }, [BuildId]);

  const getBuildingValue = () => {
    setLoading(true);

    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `/unit/show/${BuildId}`,
    })
      .then((response) => {
        setsavedImage(JSON.parse(response?.data?.unit_image));
        setViewImage(JSON.parse(response?.data?.unit_image)[0]);
        setUnitData(response?.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const changeImgUrl = (url) => {
    setViewImage(url);
  };
  return (
    <>
      <DashboardLayouts>
        {loading && <Loader />}

        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="col-xl-6 d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
            <Link
              to={
                designation === "Owner" || designation === "Partner"
                  ? "/dashboard"
                  : `/${designation}dashboard`.toLowerCase()
              }
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Dashboard</h3>
            </Link>
          </div>

          <div className="col-auto d-flex">
            <Link

to={
  designation === "Owner" || designation === "Partner"
    ? `/building-details/${building_id}`
    : `/${designation.toLowerCase()}/building-details/${building_id}`
}
              // to={`/manager/building-details/${building_id}`}
              className="btn btn-outline-primary"
            >
              Back To Unit List
            </Link>
          </div>
        </div>

        <div className="w-100 list-data">
          <h1 className="heading-text mb-4">{Buildings?.buliding_name}</h1>
        </div>

        <div className="unit-details w-100">
          <div className="unit-detail-2 row">
            <div className="col-lg details-1">
              <h1 className="heading-text mb-4">Unit Name:</h1>

              <div className="row">
                <div className="col-12 col-lg-6">
                  <h3>{unit_name}</h3>
                  <ul className="unit-list-new d-flex flex-wrap">
                    <li className="list-info">
                      <span>Building Code:</span>
                      <p>{Building_code}</p>
                    </li>

                    <li className="list-info">
                      <span>Type of Unit :</span>
                      <p>{unit_type}</p>
                    </li>

                    <li className="list-info">
                      <span>Appt Size :</span>
                      <p>{apartment_size}</p>
                    </li>

                    <li className="list-info">
                      <span>Unit Part</span>
                      <p>
                        {unitData?.unit_part}
                      </p>
                    </li>

                  
                    {/* } */}
                  </ul>
                  <ul>
                    <li className="list-info">
                      <span>Description :</span>
                      <p>{unit_description}</p>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-lg-6 mt-md-3 mt-lg-0 d-flex justify-content-lg-end">
                  <div className="area-hide add-building-img">
                    <div className="image-area d-flex align-items-center justify-content-center position-relative">
                      <div>
                        {<img src={viewImage ? viewImage : DummyImg} />}
                      </div>
                    </div>
                    <div className="add-images d-flex ">
                      {savedImage?.map((url, index) => {
                        return (
                          <div className="img-sec" key={index}>
                            <img
                              id="show-image"
                              src={url}
                              alt=""
                              onClick={() => changeImgUrl(url)}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="details-2 col-xxl-4 d-flex">
              <div>
                <div className="details-inr">
                  <h1 className="heading-text mb-4">Tenant Info</h1>

                  <ul>
                    <li>
                      <h3>Tenant Name:</h3>
                      <p>
                        {Tenant &&
                          ` ${
                            Tenant.first_name == null
                              ? "N/A"
                              : Tenant.first_name
                          } ${
                            Tenant.middle_name == null
                              ? " "
                              : Tenant.middle_name
                          } ${
                            Tenant.last_name == null ? " " : Tenant.last_name
                          } `}
                      </p>
                      {/* <h3>Tenant Code :</h3>

                    <span>
                      {Tenant &&
                        ` ${Tenant.tenant_code == null
                          ? "N/A"
                          : Tenant.tenant_code
                        } `}
                    </span> */}
                    </li>

                    <li>
                      <h3>Contact Number :</h3>
                      <p>
                        {Tenant &&
                          ` ${
                            Tenant.phone_number == null
                              ? "N/A"
                              : Tenant.phone_number
                          } `}
                      </p>
                    </li>

                    <li>
                      <h3>Email Id :</h3>
                      <p>
                        {Tenant &&
                          ` ${Tenant.email == null ? "N/A" : Tenant.email} `}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DashboardLayouts>
    </>
  );
}

export default UnitDetails;
